/**
 * Anchor ids for the filterbar grouping guided tour (ngx-ui-tour).
 *
 * These strings are duplicated as plain `tourAnchor="..."` attributes in the relevant templates
 * (Angular templates bind them statically). Keep both in sync — the value here is the source of truth.
 */
export const GROUPING_TOUR_ANCHOR = {
   /** Cog button in the filterbar that opens the settings menu. */
   settings: 'grouping-tour-settings',

   /**
    * "Groepering" item inside the settings menu. No step is anchored here — it is a submenu trigger, and
    * a popover hanging off it fights Material's hover-open. The tour only uses it to open that submenu.
    */
   groupingItem: 'grouping-tour-grouping',

   /**
    * Prefix of the per-facet anchor on every directly groupable row; the row's own id is prefix + facet.
    * One id per row rather than one id that moves to whichever row hosts the demo step: the anchor
    * directive reads `tourAnchor` once in `ngOnInit`, so a moving id would leave the old row registered
    * and make the new one throw on the duplicate. The demo step picks its id when the tour starts.
    */
   demoRowPrefix: 'grouping-tour-demo-',

   /** Active-filter chip strip in the filterbar. */
   filters: 'grouping-tour-filters',

   /** Bookmark star in the page header. */
   bookmark: 'grouping-tour-bookmark',
} as const;

/** Step ids, so orchestration side effects can key off the current step without matching on anchor. */
export const GROUPING_TOUR_STEP = {
   settings: 'grouping-step-settings',
   chooseGrouping: 'grouping-step-choose',
   stacking: 'grouping-step-stacking',
   filtering: 'grouping-step-filtering',
   bookmark: 'grouping-step-bookmark',
} as const;

/**
 * Where the tour sends a user who starts it from a page without a filterbar (the changelog notification
 * and the shortcut panel offer it everywhere). The mediaplans overview is the app's default landing page
 * and always carries a groupable filterbar.
 */
export const GROUPING_TOUR_ROUTE = 'mediaplans';
